import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const Normal = props => {
  return (
    <SvgIcon {...props} width="19" height="19" viewBox="0 0 19 19">
      <g transform="translate(-1.5 -1.019)">
        <g transform="translate(2 2)">
          <circle
            fill="none"
            stroke="#47b501"
            strokeMiterlimit={10}
            cx="9"
            cy="9"
            r="9"
            transform="translate(0 -0.481)"
          />
          <path
            fill="none"
            stroke="#47b501"
            strokeMiterlimit={10}
            d="M7.1,13.216l4.255,4.317L18.237,9.9"
            transform="translate(-3.909 -4.957)"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default Normal;
